// extracted by mini-css-extract-plugin
export default {"divider":"AttachmentAddPopup_divider__8Zd6C","menu":"AttachmentAddPopup_menu__wfGH1","menuItem":"AttachmentAddPopup_menuItem__qyA4z","tip":"AttachmentAddPopup_tip__Vaix9"};